import getCcEmail from './getCcEmail'
import setCcEmail from './setCcEmail'

export const getCcEmailAPI = getCcEmail
export const setCcEmailAPI = setCcEmail



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/actions/index.js